/** @typedef {(troubleReachingServer: boolean) => void} ServerReachabilityListener */

/** @type {boolean} */
let troubleReachingServer = false

/** @type {Set<ServerReachabilityListener>} */
const listeners = new Set()

function notifyListeners() {
  for (const listener of listeners) {
    listener(troubleReachingServer)
  }
}

export function getTroubleReachingServer() {
  return troubleReachingServer
}

export function reportServerReachable() {
  if (!troubleReachingServer) {
    return
  }

  troubleReachingServer = false
  notifyListeners()
}

export function reportServerUnreachable() {
  if (troubleReachingServer) {
    return
  }

  troubleReachingServer = true
  notifyListeners()
}

/**
 * @param {ServerReachabilityListener} listener
 * @returns {() => void}
 */
export function subscribeServerReachability(listener) {
  listeners.add(listener)
  listener(troubleReachingServer)

  return () => {
    listeners.delete(listener)
  }
}

const SERVER_REACHABILITY_MESSAGE = "SERVER_REACHABILITY"

export function installServerReachabilityListener() {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) {
    return () => {}
  }

  /** @param {MessageEvent} event */
  function onMessage(event) {
    if (event.data?.type !== SERVER_REACHABILITY_MESSAGE) {
      return
    }

    if (event.data.troubleReachingServer) {
      reportServerUnreachable()
    } else {
      reportServerReachable()
    }
  }

  navigator.serviceWorker.addEventListener("message", onMessage)
  return () => navigator.serviceWorker.removeEventListener("message", onMessage)
}

export { SERVER_REACHABILITY_MESSAGE }
